import Sidebar from "./components/Sidebar/sidebar";
import Home from "./components/Home/home"
import About from "./components/About/about"
import { BrowserRouter as Router , Routes, Route} from 'react-router-dom';
import './App.css'
import Project from "./components/Project/project";

function App() {
  return (
    <div className="App">
    <Router>
    <nav className="side">
      <Sidebar/>
    </nav>
    <div className="home">
      <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/project' element={<Project/>}/>
     </Routes>
    </div>
  </Router>
  </div>

  );
}

export default App;
